export default "__VITE_ASSET__9775efd3__"